import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import waterfall from 'vue-waterfall2'
import store from './store'
import VueLazyload from 'vue-lazyload'
import VueCropper from 'vue-cropper'
import VideoPlayer from 'vue-video-player'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false//阻止启动生产消息；
Vue.use(Vant);
Vue.use(waterfall)
Vue.use(VueLazyload, {
  lazyComponent: true,
  loading: require('./assets/img/loading.gif'),
  error: require('./assets/img/loading.gif'),
});
Vue.use(VueCropper)
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(VueClipboard)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')


